module.exports = __webpack_public_path__ + "assets/img/BETFAIR(AA051).4ee96bd1.png";